import Button from '../button/button';
import style from './confirmation.module.scss';
import buttonStyle from '../button/button.module.scss';

const Confirmation = ({ title, description, onButtonClick}) => {

    return (
        <div className={style.container}>
            <div className={style.wrapper}>
                <h2 className={style.title}>{title}</h2>
                <p className={style.description}>{description}</p>
                <div className={style.action_buttons}>
                    <Button text={'OK'} buttonType={`${buttonStyle.button_primary}`} marginTop={0} onClick={() => onButtonClick('Ok')}/>
                </div>
            </div>
        </div>
    )
}

export default Confirmation;